(function () {
  function mount(root) {
    if (root.dataset.mediaMounted) return;
    const form = document.getElementById(root.dataset.productFormId);
    if (!form) return;
    root.dataset.mediaMounted = 'true';
    const button = root.querySelector('[data-photo-choose]');
    const error = root.querySelector('[data-photo-error]');
    const host = form.closest('product-form');
    let asset;
    let allowSubmit = false;
    let submitting = false;
    let choosing = false;
    const report = message => { error.textContent = message; error.hidden = !message; };
    const property = (name, value) => {
      let field = form.querySelector(`[name="properties[${name}]"]`);
      if (!field) {
        field = document.createElement('input');
        field.type = 'hidden'; field.name = `properties[${name}]`;
        form.append(field);
      }
      field.value = value;
    };
    const showPhoto = url => {
      root.querySelector('[data-photo-preview]').classList.remove('hide');
      root.querySelector('[data-photo-image]').src = url;
      button.textContent = 'Change photo';
    };
    button.addEventListener('click', async () => {
      if (choosing || submitting) return;
      choosing = true; report('');
      try {
        if (await window.CustomerMedia.enabled()) {
          const choice = await window.CustomerMedia.choose();
          if (choice) {
            asset = choice.asset;
            property('Photo', asset.url);
            property('_media_asset_id', asset.asset_id);
            form.querySelector('[name="properties[_media_order_receipt]"]')?.remove();
            showPhoto(asset.thumbnail_url);
          }
        } else {
          throw new Error('Photo upload is unavailable. Please retry.');
        }
      } catch (failure) { report(failure.message || 'Your photo could not be saved. Please retry.'); }
      finally { choosing = false; }
    });
    form.addEventListener('submit', async event => {
      if (allowSubmit) { allowSubmit = false; return; }
      event.preventDefault(); event.stopImmediatePropagation();
      if (submitting || choosing || host?.submitButton?.getAttribute('aria-disabled') === 'true') return;
      submitting = true; report('');
      const submitter = event.submitter;
      host?.setSubmissionLoading?.(true, 'Adding…', { lock: false });
      try {
        if (!await window.CustomerMedia.enabled()) throw new Error('Photo upload is unavailable. Please retry.');
        {
          if (!asset) throw new Error('Choose a photo before adding your crystal.');
          const cart = await window.StorefrontRequest.json(`${window.routes?.root || '/'}cart/update.js`, {
            method: 'POST', body: '{}', credentials: 'same-origin', cache: 'no-store',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          }, { timeoutMs: 30000 });
          if (!cart.token) throw new Error('Your cart could not be prepared. Please retry.');
          const verified = await window.CustomerMedia.associate(asset, cart.token);
          if (verified.asset_id !== asset.asset_id || !/^[a-f0-9]{64}$/.test(verified.order_receipt || '')) {
            throw new Error('Your photo could not be verified. Please retry.');
          }
          property('Photo', verified.url);
          property('_media_asset_id', verified.asset_id);
          property('_media_order_receipt', verified.order_receipt);
        }
        // A cached gate can resolve within the original submit's microtask
        // checkpoint. Browsers suppress requestSubmit while that submit runs.
        await new Promise(resolve => setTimeout(resolve, 0));
        host?.setSubmissionLoading?.(false);
        allowSubmit = true;
        form.requestSubmit(submitter || undefined);
      } catch (failure) {
        allowSubmit = false;
        report(failure.message || 'Your photo could not be verified. Please retry.');
        host?.setSubmissionLoading?.(false);
      } finally { submitting = false; }
    }, true);
  }
  const mountAll = () => document.querySelectorAll('[data-default-photo-picker]').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll, { once: true });
  else mountAll();
  document.addEventListener('shopify:section:load', mountAll);
})();
